jQuery(document).ready(function($){

    // Image Carousel
    $('.carousel').slick({
        arrows: false,
        dots: false,
        centerMode: true,
        variableWidth: true,
        infinite: true
    });
    
});
